import { render, staticRenderFns } from "./ViewProjects.vue?vue&type=template&id=0e754acc&scoped=true&"
import script from "./ViewProjects.vue?vue&type=script&lang=ts&"
export * from "./ViewProjects.vue?vue&type=script&lang=ts&"
import style0 from "./ViewProjects.vue?vue&type=style&index=0&id=0e754acc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e754acc",
  null
  
)

export default component.exports